<template>
  <button
    v-tooltip="{
      content,
      placement: 'top',
      offset: 8,
      classes: 'tooltip--new'
    }"
    type="button"
    class="mailgun-info-tooltip"
    :aria-label="ariaLabel || content"
    @click.stop
  >
    <i class="pi pi-info-circle" aria-hidden="true" />
  </button>
</template>

<script>
export default {
  name: 'MailgunInfoTooltip',
  props: {
    content: {
      type: String,
      required: true
    },
    ariaLabel: {
      type: String,
      default: ''
    }
  }
}
</script>

<style lang="scss" scoped>
.mailgun-info-tooltip {
  display: inline-flex;
  width: 24px;
  height: 24px;
  flex: 0 0 24px;
  align-items: center;
  justify-content: center;
  padding: 0;
  border: 0;
  border-radius: 50%;
  background: transparent;
  color: $ui-muted;
  cursor: default;
  transition: background-color .16s ease, color .16s ease;
}

.mailgun-info-tooltip .pi { font-size: 18px; }
.mailgun-info-tooltip:hover { background: $ui-blue-soft; color: $ui-blue; }
.mailgun-info-tooltip:focus-visible { outline: 2px solid $ui-blue; outline-offset: 2px; color: $ui-blue; }
</style>
